var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-pt_5" }, [
    _c("div", { staticClass: "emd-container _highlight_header" }, [
      _c("div", { staticClass: "emd-container__header" }, [
        _c("h2", { staticClass: "emd-text _size_default _type_caption" }, [
          _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
        ]),
      ]),
      _c("div", { staticClass: "emd-container__content" }, [
        _c("pre", [_vm._v(_vm._s(_vm.metadata))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }